import styled from "styled-components";

import colors from "@src/common/styles/colors";
import { defaultLetterSpacing } from "@src/common/styles/mixins";
import { ReactComponent as Exclamation } from "@src/modules/shared/components/Results/icons/exclamation.svg";
import { ReactComponent as CircleNok } from "@src/modules/shared/components/Results/icons/circle-nok.svg";

export const LabelCell = styled.td`
  ${defaultLetterSpacing};
  font-weight: 600;
  color: ${colors.gray3};
`;

export const ValueCell = styled.td`
  text-align: right;
  position: relative;
`;

export const ToleranceCell = styled.td`
  text-align: right;
  color: ${colors.gray3};
`;

export const ExclamationBadge = styled(Exclamation)`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin auto 0;
  transform: translate(105%, 0);
`;

export const FailedTestCircle = styled(CircleNok)`
  color: ${colors.red};
`;
